import { BusinessDetails } from '@/types/businesses';
import { SVHiddenText, SVLink, SVSummaryCard } from '../core';
import { SVSummaryCardItem } from '@/types/common';
import { buildAddress } from '@/utils/address';
import { formatDateTimeFromUTC } from '@/utils/date';
import StatusLabel from '../StatusLabel';
import { FORM_FIELDS } from '@/constants/formFields';
import { ROUTES } from '@/constants/routes';
import { legalStructureStringGenerator } from '@/utils/business';
import { Stack } from '@mui/material';
import TeammateLink from '../TeammateLink';
import { titleCase } from '@/utils/stringCaser';

type BusinessDetailsInfo = {
  businessDetails: BusinessDetails;
};

export default function BusinessDetailsInfo({
  businessDetails,
}: BusinessDetailsInfo) {
  const {
    legalBusinessName,
    dbaName,
    company,
    status,
    createdAt,
    currentAddress,
    mailingAddress,
    kybStatus,
    legalStructure,
    tin,
    advisors,
  } = businessDetails;

  const items: SVSummaryCardItem[] = [
    {
      label: 'Legal Business Name',
      text: legalBusinessName,
    },
    {
      label: 'DBA',
      text: dbaName,
    },
    {
      label: 'Legal Structure',
      text: legalStructureStringGenerator(legalStructure),
    },
    {
      label: 'Tin',
      customContent: (
        <SVHiddenText text={tin} visibleCount={4} ariaLabel="Tin" />
      ),
    },
    {
      label: FORM_FIELDS.COMPANY.label,
      customContent: company ? (
        <SVLink to={`${ROUTES.COMPANIES}/${company.uuid}`}>
          {company.name}
        </SVLink>
      ) : null,
    },
    {
      label: 'Advisors',
      customContent: advisors?.length ? (
        <Stack spacing={1}>
          {advisors.map(advisor => (
            <TeammateLink
              key={advisor.uuid}
              uuid={advisor.uuid}
              name={`${advisor.fullName}`}
            />
          ))}
        </Stack>
      ) : null,
    },
    {
      label: 'Status',
      customContent: <StatusLabel status={status} />,
    },
    {
      label: 'KYB Status',
      text: titleCase(kybStatus),
    },
    {
      label: 'Created Date',
      text: formatDateTimeFromUTC(createdAt),
    },
    {
      label: 'Current Address',
      text: buildAddress(currentAddress),
    },
    {
      label: 'Mailing Address',
      text: buildAddress(mailingAddress),
    },
  ];

  return <SVSummaryCard label="Basic Info" items={items} />;
}
